import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_TRANSACTION } from '@/modules/transaction/router';
import { transactionService } from '@/services/transaction';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useTransactionEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        code: route.params.code as string,
        locale: route.params.locale as string,
        name: '',
        content: ''
    });

    const fetch = crudAction.executeAction({
        request: () => transactionService.text.getContent(model.code, model.locale),
        onSuccess: ({ data }) => {
            model.name = data.name;
            model.content = data.content;
        },
        onError: () => router.push({ name: ROUTE_NAME_TRANSACTION.TEXT.INDEX, query: { locale: model.locale } })
    });

    const update = crudAction.excuteAndNotify({
        request: () => transactionService.text.updateContent(model.code, model.locale, model.content),
        onSuccess: () => router.push({ name: ROUTE_NAME_TRANSACTION.TEXT.INDEX, query: { locale: model.locale } })
    });

    return { model, fetch, update };
}
